var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './EndAX.scss';
import KodanshaSubmit from '../KodanshaUIKit/KodanshaSubmit/KodanshaSubmit';
import { useWindowSize } from '../Hooks/useWindowSize';
import { useAtom } from 'jotai';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import { LoginStatusAtom } from '../../store/AccountStore';
var EndAX = function () {
    var width = useWindowSize().width;
    var _a = __read(useAtom(LoginStatusAtom), 1), loginStatus = _a[0];
    var _b = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _b[1];
    return (_jsxs("div", { className: 'ax-end-container', children: [_jsxs("div", { className: 'ax-end-more-wrapper', children: [_jsx("h3", { className: 'ax-end-more-header', children: "And More!" }), _jsx("p", { className: 'ax-end-more-text', children: width < 1280 ?
                            "As new  features are added, we'll make sure to notify Readers. \n                        If not a Reader, sign up for the newsletter or follow on social."
                            :
                                "We'll make sure to keep you informed as new features are added. If you're not\n                    already a Kodansha Reader, we invite you to subscribe to one of our newsletters\n                    and follow us on social media for future updates." })] }), loginStatus !== "LoggedIn" &&
                _jsx(KodanshaSubmit, { text: 'Create Account', styles: 'ax-create-account-btn', onSubmitClicked: function () { return setLoginOverlay(true); } }), _jsx("span", { className: 'ax-digital-manga-notice', children: "*Digital manga can be read from anywhere. Digital purchases are not available in Japan." })] }));
};
export default EndAX;
